import { IInstructor } from 'api/employee/dtos';
import { BaseEntity, BusinessQuery, Permission } from 'api/shared';
import { User } from '../me/dtos';
import { Subscription } from '../subscription/dtos';

export interface UpdateMembershipRequest extends BusinessQuery {
  id: number;
  permissions: Permission[];
}

export interface Membership extends BaseEntity {
  id: number;
  user: User;
  employee?: Pick<IInstructor, 'id' | 'email' | 'personal'>;
  permissions: Permission[];
  role: RoleTypeEnum;
  scopeChangedAt: string;
  business?: {
    id: number;
    name: string;
    subscription: Pick<Subscription, 'validTo' | 'customerEmail' | 'invoiceStatus' | 'status'>;
  };
}

export enum RoleTypeEnum {
  OWNER = 'owner',
  USER = 'user',
  PENDING = 'pending',
  PUBLIC = 'public',
}

export interface DeleteMembershipRequest {
  id: number;
}
